import React, { useState, useCallback } from "react";
import { EditOutlined, InboxOutlined, LoadingOutlined, CheckCircleTwoTone, UserOutlined } from "@ant-design/icons";
import { Modal, Upload, Spin, message } from "antd";
import { connect } from "dva";
import { ProfilePictureStatus } from "@/utils/enum";
import SignedLinkWrapper from "@/components/SignedLinkWrapper";

const { Dragger } = Upload;

const ProfilePicture = ({ loadingSubmitProfilePicture, disabled, previousProfilePicture, uploadFn }) => {
  const [visibleEditProfile, setVisibleEditProfile] = useState(false);
  const [profilePictureStatus, setProfilePictureStatus] = useState(ProfilePictureStatus.Idle);
  const [profilePicture, setProfilePicture] = useState(null);

  const openEditUserProfile = useCallback(() => {
    setVisibleEditProfile(true);
    setProfilePictureStatus(ProfilePictureStatus.Idle);
  }, []);

  const saveNewProfilePic = useCallback(
    ({ onSuccess, file }) => {
      if (typeof uploadFn !== "function") {
        return;
      }

      setProfilePictureStatus(ProfilePictureStatus.Uploading);

      uploadFn(file).then(url => {
        setProfilePicture(url);
        setProfilePictureStatus(ProfilePictureStatus.Success);

        onSuccess();

        message.success("Profile picture uploaded successfully!");

        setTimeout(() => {
          setVisibleEditProfile(false);
        }, 500);
      });
    },
    [uploadFn],
  );

  return (
    <>
      <div>
        <Spin spinning={loadingSubmitProfilePicture === true}>
          <div
            style={{
              borderRadius: "50%",
              width: "140px",
              height: "140px",
              position: "relative",
              margin: "32px auto",
            }}
          >
            {profilePicture || previousProfilePicture ? (
              <SignedLinkWrapper privateUrl={profilePicture || previousProfilePicture}>
                {signedUrl => (
                  <img
                    src={signedUrl}
                    style={{
                      borderRadius: "50%",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                    }}
                  />
                )}
              </SignedLinkWrapper>
            ) : (
              <div
                style={{
                  borderRadius: "50%",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f2f2f2",
                  boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                }}
              >
                <UserOutlined style={{ fontSize: 64 }} />
              </div>
            )}
            {!disabled && (
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "-7px",
                  borderRadius: "50%",
                  height: "33px",
                  width: "33px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#2D6AC4",
                  cursor: "pointer",
                }}
                onClick={openEditUserProfile}
              >
                <EditOutlined style={{ fontSize: 19, color: "#fff" }} />
              </div>
            )}
          </div>
        </Spin>
      </div>

      <Modal
        title="Edit Profile Pic"
        visible={visibleEditProfile}
        onCancel={() => setVisibleEditProfile(false)}
        footer={null}
      >
        {profilePictureStatus === ProfilePictureStatus.Idle ? (
          <Dragger
            name="bolFile"
            customRequest={saveNewProfilePic}
            accept="image/png,image/jpg,image/jpeg"
            showUploadList={false}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload a new profile pic.</p>
          </Dragger>
        ) : (
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {profilePictureStatus === ProfilePictureStatus.Uploading ? (
              <Spin indicator={<LoadingOutlined style={{ fontSize: 64 }} />} />
            ) : profilePictureStatus === ProfilePictureStatus.Success ? (
              <CheckCircleTwoTone twoToneColor="#23D737" style={{ fontSize: 64 }} />
            ) : null}
          </div>
        )}
      </Modal>
    </>
  );
};

export default connect(({ loading }) => ({
  loadingSubmitProfilePicture: loading.effects["user/updatePicProfile"],
}))(ProfilePicture);
